import { styled } from '@mui/system';

export const ROW_HEIGHT = 60;

const TableFilterRow = styled('div')({
  display: 'flex',
  gap: 16,
  height: ROW_HEIGHT,
  alignItems: 'center'
});

export default TableFilterRow;
